import React from 'react';
import './ToolsSection.css';


import figmaLogo from '../../assets/figma.svg';
import reactLogo from '../../assets/react.svg';
import jsLogo from '../../assets/js.svg'; 
import arrowsLogo from '../../assets/axios.svg'; 
import flowLogo from '../../assets/fastapi.svg';
import featherLogo from '../../assets/sqlite.svg'; 

function ToolsSection() {
  const tools = [
    { logo: figmaLogo, name: 'Figma' },
    { logo: reactLogo, name: 'React' },
    { logo: jsLogo, name: 'JavaScript' },
    { logo: arrowsLogo, name: 'Axios' },
    { logo: flowLogo, name: 'FastAPI' }, 
    { logo: featherLogo, name: 'SQLite' }, 
    
  ];

  return (
    <section id="ferramentas" className="tools-section">
      <div className="container">
        <span className="subtitle">FERRAMENTAS</span>
        <h2>Tecnologias utilizadas</h2> {/* Título ajustado para "utilizadas" */}

        <div className="tools-grid">
          {tools.map((tool, index) => (
            <div className="tool-item" key={index}>
              <img src={tool.logo} alt={tool.name} className="tool-logo" />
              {/* No print, não parece ter o nome da ferramenta abaixo, apenas o logo. */}
              {/* Se precisar do nome, descomente ou adicione um p/span aqui: */}
              {/* <p className="tool-name">{tool.name}</p> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ToolsSection;